import React, { useState, useEffect, SyntheticEvent } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { connect } from 'react-redux';
import Navbar from '../Navbar';
import RegionesYcomunas from '../RegisterForm/regionesComunas';
import { PerfilTypes } from '../../Types/PerfilTypes';
import './editPetsitter.css';
import Footer from '../Footer';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';

function mapStateToProps (state: any) {
  return { action: state }; // this will be available in HomeScreen as props.action
}

function EditPetsitter (props: PerfilTypes) {
  const [name, setName] = useState('');
  const [description, setDescription] = useState('');
  const [region, setRegion] = useState('');
  const [commune, setCommune] = useState('');
  const [imageUrl, setImageUrl] = useState('');

  const [comunas, setComunas] = useState<Array<string>>([]);

  const [verification, setVerification] = useState(false);

  const navigate = useNavigate();

  async function getDefaultData() {
    const token = JSON.parse(localStorage.getItem('token') || '');
    await axios.get(process.env.REACT_APP_URL + '/petsitters/' + props.action.user.credenciales.id, { headers: { Authorization: 'Bearer ' + token } })
      .then((response) => {
        setName(response.data.petsitter.IsPetsitter[0].name);
        setDescription(response.data.petsitter.IsPetsitter[0].description);
        setRegion(response.data.petsitter.IsPetsitter[0].addressRegion);
        Object.values(RegionesYcomunas)[0].forEach(reg => {
          if (reg.NombreRegion === response.data.petsitter.IsPetsitter[0].addressRegion) {
            setComunas(reg.comunas);
          }
        });
        setCommune(response.data.petsitter.IsPetsitter[0].addressComuna);
        setImageUrl(response.data.petsitter.IsPetsitter[0].profileUrlImg);
      });

    if (props.action.user.credenciales.rol === 2) {
      await axios.get(process.env.REACT_APP_URL + '/vets/' + props.action.user.credenciales.id, { headers: { Authorization: 'Bearer ' + token } })
        .then((response) => {
          if (response.data.vet.verified_status === 'verified') {
            setVerification(true);
          }
        });
    }
  }

  function handleRegion(event: SyntheticEvent) {
    event.preventDefault();
    const currentRegion = (event.target as HTMLInputElement).value;
    setRegion(currentRegion);
    Object.values(RegionesYcomunas)[0].forEach(reg => {
      if (reg.NombreRegion === currentRegion) {
        setComunas(reg.comunas);
        setCommune(reg.comunas[0]);
      }
    });
  };

  async function volver () {
    if (props.action.user.credenciales.isvet === 'NO') {
      navigate('/perfil/' + props.action.user.credenciales.id);
    } else {
      navigate('/perfilVet/' + props.action.user.credenciales.id);
    }
  };

  async function deletePetsitter(event: SyntheticEvent) {
    event.preventDefault();
    const token = JSON.parse(localStorage.getItem('token') || '');
    await axios.delete(process.env.REACT_APP_URL + '/petsitters/' + props.action.user.credenciales.id, { headers: { Authorization: 'Bearer ' + token } });
    if (!verification) {
      navigate('/perfil/' + props.action.user.credenciales.id);
    } else {
      navigate('/perfilVet/' + props.action.user.credenciales.id);
    }
  }

  async function handleSubmit(event: SyntheticEvent) {
    event.preventDefault();
    const token = JSON.parse(localStorage.getItem('token') || '');
    await axios.patch(process.env.REACT_APP_URL + '/petsitters/' + props.action.user.credenciales.id, { name, description, addressRegion: region, addressComuna: commune, profileUrlImg: imageUrl }, { headers: { Authorization: 'Bearer ' + token } })
      .then((response) => {
        console.log(response);
      }).catch((error) => {
        console.log(error);
      });
    if (!verification) {
      navigate('/perfil/' + props.action.user.credenciales.id);
    } else {
      navigate('/perfilVet/' + props.action.user.credenciales.id);
    }
  }

  function convertToBase64(file: any) {
    return new Promise(resolve => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => {
        resolve(reader.result);
      };
    });
  };

  async function onFileChange(event: any) {
    event.preventDefault();
    const convertedFile = await convertToBase64(event.target.files[0]);
    setImageUrl(String(convertedFile));
  };

  useEffect(() => {
    getDefaultData();
  }, []);

  return (
    <>
      <Navbar logged={true}/>
      <div className='form-container' style={{ height: '80vh' }}>
        <div className='title'>Editar Petsitter</div>
        <form onSubmit={handleSubmit}>
          <div className='field-container'>
            <input className='register-form-input' name="name" onChange={(e) => setName(e.target.value)} value={name} required/>
            <label className="edit-profile-label" htmlFor="name">Nombre del Servicio</label>
          </div>
          <div className='field-container'>
            <input className='register-form-input' name="description" onChange={(e) => setDescription(e.target.value)} value={description} />
            <label className="edit-profile-label" htmlFor="description">Descripción</label>
          </div>
          <div className='field-container'>
            <select className="box-campo" id="region" name="region" value={region} onChange={(e) => handleRegion(e)} required>
              <option value="" defaultValue="" disabled hidden></option>
              {Object.values(RegionesYcomunas)[0].map((region) => {
                return <option key={region.NombreRegion}>{region.NombreRegion}</option>;
              })}
            </select>
            <label className="edit-profile-label" htmlFor="region">Región</label>
          </div>
          <div className='field-container'>
            <select className="box-campo" id="commune" name="commune" value={commune} onChange={(e) => setCommune(e.target.value)} required>
              <option value="" defaultValue="" disabled hidden></option>
              {comunas.map((comuna) => (<option key={comuna}>{comuna}</option>))}
            </select>
            <label className="edit-profile-label" htmlFor="commune">Comuna</label>
          </div>
          <p style={{ display: 'flex', justifyContent: 'center', marginTop: '40px' }}>
                            <label htmlFor="profileUrlImg" className="upload-label">
                              Cambiar foto
                              <input
                                className="register-form-input"
                                type="file"
                                onChange={onFileChange}
                                name="profileUrlImg"
                                id="profileUrlImg"
                              />
                              <CloudUploadIcon className="upload-icon" />
                            </label>
                          </p>
          <div className='upload-button-container'>
            <button className="save-button" onClick={volver}> Volver </button>
            <button className="save-button" value="submit"> Guardar </button>
            <button className="delete-button" onClick={deletePetsitter}> Eliminar </button>
          </div>
        </form>
      </div>
      <Footer />
    </>
  );
};

export default connect(mapStateToProps)(EditPetsitter);
